module.exports = " <label class=\"btn btn-{{ buttonStyle }} {{ buttonSize ? `btn-${buttonSize}` : '' }} {{* checked ? 'active' : '' }}\" @click=handleClick> <input type=checkbox> <slot></slot> </label> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ui/checkbox-button.vue
// module id = 226
// module chunks = 0